import React, { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  Lightbulb,
  ExternalLink,
  FileText,
} from "lucide-react";

const PersonaSegmentation = ({ response }: any) => {
  const [expandedStrategy, setExpandedStrategy] = useState<number | null>(null);

  const supportStrategies = response?.persona_segmentation?.personas || [];

  return (
    <div className="h-[90vh] p-4 border rounded-xl border-gray-300 overflow-y-auto pn_scroller">
      <div className="max-w-5xl mx-auto space-y-4">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <Lightbulb className="w-3 h-3 text-blue-600" />
          <h1 className="text-md font-semibold text-slate-800">
            Persona Segmentation
          </h1>
        </div>

        {/* Strategies */}
        {supportStrategies.map((item: any, index: number) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden"
          >
            {/* Strategy Header */}
            <div
              className="p-2 flex justify-between items-start cursor-pointer hover:bg-slate-50 transition"
              onClick={() =>
                setExpandedStrategy(expandedStrategy === index ? null : index)
              }
            >
              <div className="flex flex-col gap-1">
                <h2 className="text-sm font-semibold text-slate-800 leading-snug">
                  {item.persona}
                </h2>
              </div>
              {expandedStrategy === index ? (
                <ChevronDown className="w-2 h-2 text-slate-500" />
              ) : (
                <ChevronRight className="w-2 h-2 text-slate-500" />
              )}
            </div>

            {/* Expanded Section */}
            {expandedStrategy === index && (
              <div className="bg-slate-50 border-t border-slate-200 p-4 space-y-4">
                {/* Description */}
                <div>
                  <p className="text-[11px] text-slate-500 font-medium uppercase mb-1">
                    Characteristics
                  </p>

                  {item.characteristics.map((text:any , index:any)=>(
                     <p key={index} className="text-sm text-slate-700 leading-relaxed">
                      {text}
                    </p>

                  ))}

                   <p className="text-[11px] text-slate-500 font-medium uppercase mb-1 mt-2">
                    Challenges
                  </p>

                  {item.challenges.map((text:any , index:any)=>(
                     <p key={index} className="text-sm text-slate-700 leading-relaxed">
                      {text}
                    </p>

                  ))}

                   <p className="text-[11px] text-slate-500 font-medium uppercase mb-1 mt-2">
                    Motivations
                  </p>

                  {item.motivations.map((text:any , index:any)=>(
                     <p key={index} className="text-sm text-slate-700 leading-relaxed">
                      {text}
                    </p>

                  ))}
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Tip */}
        <div className="mt-6 bg-blue-50 rounded-lg p-3 border border-blue-200">
          <p className="text-sm text-blue-800">
            <strong>Tip:</strong> Click on a strategy to explore its detailed
            description and supporting external sources.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonaSegmentation;
